// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */
export const QUICK_FIND_RECENT_ACTIVITIES_CACHE_KEY = 'quick-find-recent-activities';
